/** Whether any connection needs attention. A disconnection the user asked for doesn't count. */
export const hasConnectionIssue = (whatsApps = []) => whatsApps.some((whats) => {
  const isManualDisconnect =
    (whats.status === "DISCONNECTED" || whats.status === "PENDING" || whats.status === "qrcode") &&
    whats.disconnectReason === "manual";
  if (isManualDisconnect) return false;

  return (
    whats.status === "qrcode" ||
    whats.status === "PAIRING" ||
    whats.status === "PENDING" ||
    whats.status === "DISCONNECTED" ||
    whats.status === "TIMEOUT" ||
    whats.status === "OPENING"
  );
});
